var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconOpenLink = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 5.75c0 .416.334.75.75.75h3.191l-6.973 6.969a.75.75 0 0 0 1.06 1.06l6.97-6.97v3.191c0 .416.334.75.75.75s.75-.334.75-.75v-5a.748.748 0 0 0-.75-.75h-4.998a.748.748 0 0 0-.75.75zM7.25 6A2.249 2.249 0 0 0 5 8.25v10.5A2.249 2.249 0 0 0 7.25 21h10.502a2.249 2.249 0 0 0 2.25-2.25v-4a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v4c0 .416-.334.75-.75.75H7.25a.748.748 0 0 1-.75-.75V8.25c0-.416.335-.75.75-.75h4.001c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-4z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOpenLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-open-link.07eda5d4.svg";
export { ForwardRef as ReactComponent };